const partnershipsAltTextI18nEn = {
  'altTextMonikaImage': 'Dr. Monika Hauck founder Repair Rebels - brand partnerships',
  'altTextExpertiseImage': 'Repair Rebels expertise white-label repair platform for brands',
  'altTextBikeImage': 'Circular fashion - repair-as-a-service platform',
};

export default partnershipsAltTextI18nEn;
